query blockRangesData($scenarioId: ID!) {
  data(scenarioId: $scenarioId) {
    allBlocks {
      id
      startingTime
      endingTime
    }
  }
}
